import { render, staticRenderFns } from "./GroupAdminRulesComponent.vue?vue&type=template&id=70b5f21e&scoped=true&"
import script from "./GroupAdminRulesComponent.vue?vue&type=script&lang=js&"
export * from "./GroupAdminRulesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b5f21e",
  null
  
)

export default component.exports